export enum TipoEntidadType{
    EPS= "EPS",
    CCF= "CCF",
    AFP= "AFP",
    ARL= "ARL",
    ALL= "ALL"
}
